import React, { useState } from 'react';
import { Button, UncontrolledTooltip } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import api from "../../../../api";
import apifuctions from "../../../../api/functions";

const PROPERTIES = {
    "MOSTRAR": {
        fewSelected: "Mostrar {x} Artículos Seleccionados",
        allSelected: "Mostrar Todos los Artículos",
        icon: "fa fa-eye",
        color: "success",
    },
    "OCULTAR": {
        color: "danger",
        fewSelected: "Ocultar {x} Artículos Seleccionados",
        allSelected: "Ocultar Todos los Artículos",
        icon: "fa fa-eye-slash",
    }
};

const ShowArticulosBtn = (props) => {
    const {
        idComponent, multiSelect,
        id, multiSelectIDs, action, onSubmit,
        filters,
    } = props;

    const [showSpinner, updateSpinner] = useState(false);
    const [modal, setModal] = useState(false);
    const toggle = () => setModal(!modal);

    const sendData = (evt) => {
        evt.preventDefault();
        updateSpinner(true);
        setModal(false);
        const data = {
            Show: action === "MOSTRAR",
            filters:{
                rubro_id: filters.rubro_id,
                linea_id: filters.linea_id,
                grupo_id: filters.grupo_id,
                marca_id: filters.marca_id,
                proveedor_id: filters.proveedor_id,
                categoria_id: filters.categoria_id,
                somethingSelected: filters.somethingSelected,
                byTitulo: (filters.tituloInputNode && filters.tituloInputNode.value) ? filters.tituloInputNode.value : "",
                byCodigo: (filters.codigoInputNode && filters.codigoInputNode.value) ? filters.codigoInputNode.value : "",

                Articulos_ids: multiSelectIDs() ? multiSelectIDs() : [],
            }
        }
        const successCallback = (response) => {
            updateSpinner(false);
            onSubmit && onSubmit();
        }
        const failureeCallback = () => updateSpinner(false);
        apifuctions.put(api.gestion.articulos.articulosEditarMany, null, data, successCallback, failureeCallback, failureeCallback);
    }

    const selectedItems = multiSelect ? (multiSelectIDs() ? multiSelectIDs().length : 0) : (id() ? 1 : 0);
    let msg = selectedItems > 0 ? (
        PROPERTIES[action].fewSelected && PROPERTIES[action].fewSelected.replace("{x}", selectedItems)
    ) : (
        PROPERTIES[action].allSelected && PROPERTIES[action].allSelected + (
            filters.somethingSelected ? " Filtrados" : ""
        )
    );
    if (selectedItems == 1) {
        msg = msg.replace("Artículos Seleccionados", "Artículo Seleccionado")
    }

    return (
        <div>
            <Button disabled={showSpinner} id={idComponent} onClick={() => setModal(true)} color={PROPERTIES[action].color} className="rounded tiny-btn">
                <i className={showSpinner ? "fa fa-spinner fa-spin" : PROPERTIES[action].icon} aria-hidden="true"></i>
            </Button>
            <Modal className={`modal-${PROPERTIES[action].color}`} isOpen={modal} toggle={toggle}>
                <ModalHeader toggle={toggle}>Visibilidad de Artículos</ModalHeader>
                <ModalBody>
                    <p>Artículos Seleccionados: <strong>
                        {
                            selectedItems > 0 ? (
                                selectedItems == 1 ? (
                                    `${selectedItems} Artículo`
                                ) : (
                                    `${selectedItems} Artículos`
                                )
                            ) : (
                                filters.somethingSelected ? (
                                    "Todos los Artículos Filtrados"
                                ) : (
                                    "Todos los Artículos"
                                )
                            )
                        }</strong></p>
                    <p>{`¿Esta seguro que desea ${msg}?`}</p>
                </ModalBody>
                <ModalFooter>
                    <Button color={PROPERTIES[action].color} onClick={sendData}>Confirmar</Button>{' '}
                    <Button color="secondary" onClick={toggle}>Cancelar</Button>
                </ModalFooter>
            </Modal>
            <UncontrolledTooltip placement="bottom" target={idComponent}>{msg}</UncontrolledTooltip>
        </div >
    )
}

export default ShowArticulosBtn;


// WEBPACK FOOTER //
// ./src/views/Gestion/Articulos/Articulos/ShowArticulosBtn.js